import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

//sass
import "./login.scss";

// ICON material ui
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PersonIcon from "@mui/icons-material/Person";

// components Material UI
import { Button, TextField } from "@mui/material";

// function
import { loginWS } from "./loginApi";

// common components
import SnackBar from "../../components/snackbar/SnackBar";

function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const handleLogin = async () => {
    await loginWS({ email, password });
  };

  return (
    <div className="background">
      <div className="containerLogin">
        <div className="imgLogo">
          <img src="/logo.svg" alt="Logo" />
        </div>
        <div className="formData">
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyPress}
            required
            InputProps={{
              startAdornment: <PersonIcon />,
            }}
            sx={{
              marginBottom: 2,
              "& .MuiInputLabel-root": {
                color: "#000", // Imposta il colore della label a nero
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#000", // Imposta il colore del bordo a nero
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#000", // Colore del bordo quando il campo è in focus
                },
                "& .MuiInputBase-input": {
                  color: "#000", // Imposta il colore del testo a nero
                },
              },
            }}
          />

          {/* Password input */}
          <TextField
            label="Password"
            variant="outlined"
            fullWidth
            type={showPassword ? "text" : "password"}
            value={password}
            minLength={8}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyPress}
            required
            InputProps={{
              startAdornment: <LockIcon />,
              endAdornment: (
                <span
                  onClick={handleTogglePassword}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </span>
              ),
            }}
            sx={{
              marginBottom: 2,
              "& .MuiInputLabel-root": {
                color: "#000", // Imposta il colore della label a nero
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#000", // Imposta il colore del bordo a nero
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#000", // Colore del bordo quando il campo è in focus
                },
                "& .MuiInputBase-input": {
                  color: "#000", // Imposta il colore del testo a nero
                },
              },
            }}
          />

          {/* Submit button */}
          <Button
            variant="contained"
            fullWidth
            color="primary"
            onClick={handleLogin}
            sx={{
              marginTop: 2,
              padding: "10px 0",
            }}
          >
            Accedi
          </Button>
        </div>
      </div>
      <SnackBar />
    </div>
  );
}

export default Login;
